"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.additionalAnotherTranslationUserPrompt = exports.defaultProofReadingPrompt = exports.defaultTranslationPrompt = exports.chatCompletionWithContext = exports.searchSegment = exports.prepareTranslation = exports.chatCompletion = exports.getApiEndPoint = void 0;
const auth_1 = require("firebase/auth");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const functions_1 = require("firebase/functions");
const zod_1 = require("zod");
const string_1 = require("utils/string");
const auth = (0, auth_1.getAuth)(firebase_app_1.default);
const functions = (0, functions_1.getFunctions)(firebase_app_1.default, "asia-northeast1");
const useEmulator = !!localStorage.getItem("useEmulator");
if (useEmulator) {
    (0, functions_1.connectFunctionsEmulator)(functions, "localhost", 5001);
}
const getApiEndPoint = () => {
    if (useEmulator && location.hostname === "localhost") {
        return "http://127.0.0.1:8000";
    }
    else {
        return process.env["REACT_APP_API_END_POINT"] || "";
    }
};
exports.getApiEndPoint = getApiEndPoint;
const callApi = (_a) => __awaiter(void 0, [_a], void 0, function* ({ path, body, controller, }) {
    var _b;
    const idToken = yield ((_b = auth.currentUser) === null || _b === void 0 ? void 0 : _b.getIdToken());
    return fetch((0, exports.getApiEndPoint)() + path, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify(body),
        signal: controller === null || controller === void 0 ? void 0 : controller.signal,
    });
});
const chatCompletion = ({ messages, controller, model, stream = true, }) => {
    return callApi({
        path: "/chatCompletion",
        body: {
            model,
            messages,
            stream,
        },
        controller,
    });
};
exports.chatCompletion = chatCompletion;
const prepareTranslation = ({ text, langId, projectId, controller, }) => {
    return (0, functions_1.httpsCallable)(functions, "prepareTranslation")({
        text,
        langId,
        projectId,
    });
};
exports.prepareTranslation = prepareTranslation;
const searchSegment = (_c) => __awaiter(void 0, [_c], void 0, function* ({ text, projectId, controller, exceptSegmentId, }) {
    const res = yield (0, functions_1.httpsCallable)(functions, "searchSegment")({
        text,
        projectId,
        exceptSegmentId,
    });
    const json = res.data;
    const parsed = zod_1.z.object({ segments: zod_1.z.array(zod_1.z.string()) }).parse(json);
    return parsed.segments;
});
exports.searchSegment = searchSegment;
const chatCompletionWithTemplate = ({ model, stream = true, params, prompt, additionalPrompt, controller, }) => {
    const systemContent = (additionalPrompt === null || additionalPrompt === void 0 ? void 0 : additionalPrompt.system)
        ? (0, string_1.applyTemplate)(prompt.system, params) + "\n" + additionalPrompt.system
        : (0, string_1.applyTemplate)(prompt.system, params);
    const userContent = (additionalPrompt === null || additionalPrompt === void 0 ? void 0 : additionalPrompt.user)
        ? (0, string_1.applyTemplate)(prompt.user, params) + "\n" + additionalPrompt.user
        : (0, string_1.applyTemplate)(prompt.user, params);
    console.log({ systemContent, userContent });
    return (0, exports.chatCompletion)({
        model,
        stream,
        messages: [
            {
                role: "system",
                content: systemContent,
            },
            {
                role: "user",
                content: userContent,
            },
        ],
        controller,
    });
};
const chatCompletionWithContext = ({ model, stream = true, context, params, prompt, additionalPrompt, controller, }) => {
    const joinedContext = context
        .map((c) => `${c.text} -> ${c.translation}`)
        .join("\n");
    const finalPrompt = Object.assign(Object.assign({}, prompt), additionalPrompt);
    const systemPrompt = (0, string_1.applyTemplate)(finalPrompt.system, Object.assign(Object.assign({}, params), { joinedContext }));
    const userPrompt = (0, string_1.applyTemplate)(finalPrompt.user, Object.assign(Object.assign({}, params), { joinedContext }));
    console.log("=== Final LLM Prompt ===");
    console.log("System Prompt:", systemPrompt);
    console.log("User Prompt:", userPrompt);
    console.log("Context:", joinedContext);
    console.log("=== End Prompt ===");
    return chatCompletionWithTemplate({
        model,
        stream,
        params: Object.assign(Object.assign({}, params), { joinedContext }),
        prompt: finalPrompt,
        additionalPrompt,
        controller,
    });
};
exports.chatCompletionWithContext = chatCompletionWithContext;
var translate_prompts_1 = require("translate-prompts");
Object.defineProperty(exports, "defaultTranslationPrompt", { enumerable: true, get: function () { return translate_prompts_1.defaultTranslationPrompt; } });
Object.defineProperty(exports, "defaultProofReadingPrompt", { enumerable: true, get: function () { return translate_prompts_1.defaultProofReadingPrompt; } });
const additionalAnotherTranslationUserPrompt = (translationList) => `# Previous translations to avoid if possible:\n ${translationList.map((translation, index) => `${index + 1}. ${translation}`).join("\n")}`;
exports.additionalAnotherTranslationUserPrompt = additionalAnotherTranslationUserPrompt;
